import React from "react";
import { useNavigate } from "react-router-dom";
import { Mic, Headphones, ArrowRight, Radio } from "lucide-react";
import { Badge } from "../components/ui/badge";

const ModeCard = ({ icon: Icon, title, description, onClick, testId, accent }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className="group flex w-full items-center gap-4 rounded-[var(--radius)] border border-border/80 bg-card/80 px-5 py-6 text-left backdrop-blur transition-colors hover:border-border hover:bg-card/95 active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
  >
    <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-border/70 ${accent}`}>
      <Icon className="h-6 w-6" />
    </span>
    <span className="flex-1">
      <span className="block text-lg font-semibold text-foreground" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
        {title}
      </span>
      <span className="mt-0.5 block text-sm text-muted-foreground">{description}</span>
    </span>
    <ArrowRight className="h-5 w-5 text-muted-foreground transition-colors group-hover:text-foreground" />
  </button>
);

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="aurora-bg pointer-events-none absolute inset-x-0 top-0 h-64" />
      <main className="relative mx-auto flex min-h-screen max-w-[520px] flex-col px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-14">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-border/70 bg-secondary/60 px-2.5 py-1 text-xs text-muted-foreground">
              <Radio className="h-3 w-3 text-[hsl(var(--accent))]" />
              Realtime AI Translation
            </div>
            <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
              Dijital Roket Translate
            </h1>
            <p className="mt-3 text-base text-muted-foreground">
              Anlık sesli ve yazılı çeviri: Türkçe · English · Azərbaycanca · Русский
            </p>
          </div>
        </div>

        <div className="mt-4">
          <Badge variant="secondary" data-testid="home-room-badge" className="font-mono text-xs" style={{ fontFamily: "'Roboto Mono', monospace" }}>
            Oda: DEMO01
          </Badge>
        </div>

        <div className="mt-8 space-y-4">
          <ModeCard
            icon={Mic}
            title="Konuşmacı"
            description="Mikrofonu aç, konuş; çeviri dinleyicilere yayınlansın."
            onClick={() => navigate("/speaker")}
            testId="home-speaker-mode-button"
            accent="bg-[hsl(var(--state-live))]/10 text-[hsl(var(--state-live))]"
          />
          <ModeCard
            icon={Headphones}
            title="Dinleyici"
            description="Yayını dinle; çeviri metnini canlı gör."
            onClick={() => navigate("/listener")}
            testId="home-listener-mode-button"
            accent="bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))]"
          />
        </div>

        <div className="mt-auto pt-10">
          <p className="text-center text-xs text-muted-foreground">
            🎙️ Speaker → AI Translation → 🎧 Listener · Dijital Roket
          </p>
        </div>
      </main>
    </div>
  );
}
